<template>
  <main-right title="客户信息">
    <AccountTab
      :minWidth="825"
      :arrItems="tabs"
      v-model="curTab">
      <CheckStatus :status="auditState"></CheckStatus>
      <div class="acc_content">
        <keep-alive>
          <component :is="curComp" :customer="customer"></component>
        </keep-alive>
      </div>
    </AccountTab>
  </main-right>
</template>

<script>
import AccountTab from './component/AccountTab'
import CheckStatus from './component/CheckStatus'
import FormFirm from './component/FormFirm'
import FormPerson from './component/FormPerson'

const opts = [{ label: '企业广告主', value: 2 }, { label: '个人广告主', value: 1 }]

export default {
  name: 'AccountInfo',
  components: { AccountTab, CheckStatus, FormFirm, FormPerson },
  data () {
    return {
      tabs: [],
      curTab: undefined,
      auditState: -2 // 客户认证状态(-2:未提交资料(即游客客户,由前端定义的值),-1:审核中,0:审核未通过,1:审核通过(生效),2:认证已过期)
    }
  },
  computed: {
    curComp () {
      return this.curTab === 2 ? 'form-firm' : 'form-person'
    },
    cusId () {
      const adUser = this.$store.state.customer.userInfo
      if (adUser && adUser.customerId) return adUser.customerId
      return null
    },
    customer () {
      return this.$store.state.customer.customerInfo
    }
  },
  watch: {
    customer: {
      immediate: true,
      handler (nv) {
        if (!this.isEmpty(nv) && nv.advertiserType) { // 填写过个人或企业资料
          const tp = nv.advertiserType
          this.tabs = tp === 1 ? [opts[1]] : [opts[0]]
          this.curTab = tp
          this.auditState = nv.checkStatus // 资料审核状态
        } else { // 未填写资料
          console.log('%c 未填写客户资料', 'background:#ddd;color:#D50000;padding:2px 6px 2px 0')
          this.tabs = opts
          this.curTab = 2
        }
      }
    }
  },
  beforeDestroy () {
    document.body.className = ''
  },
  created () {
    document.body.className = 'body-account'
    // 在此请求客户资料保证切页面时如果客户认证状态有变化能及时更新
    if (this.cusId) this.$store.dispatch('customer/getCustomerInfo', this.cusId)
  }
}
</script>

<style lang="scss">
.body-account {
  .layout_index {
    min-width: 1400px;
  }
}
</style>
<style lang="scss" scoped>
.acc_content {
  width: 1060px;
}
</style>
